import { Box, Modal } from '@mui/material';

interface Props {
	open: boolean;
	children: React.ReactNode;
	isChildren?: boolean;
	onClose: () => void;
}

export const ProductDetailsSizesGuideAdaptiveDialog: React.FC<Props> = ({
	open,
	children,
	isChildren = false,
	onClose,
}) => {
	return (
		<Modal
			open={open}
			sx={{ zIndex: isChildren ? 9999 : 9998 }}
			disableScrollLock
			onClose={onClose}
		>
			<Box
				sx={{
					width: '100%',
					height: '100%',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<Box
					sx={{
						backgroundColor: 'white',
						borderRadius: { xs: 0, md: 2 },
						width: '100%',
						maxWidth: { xs: '100%', md: '600px' },
						height: '100%',
						maxHeight: { xs: '100%', md: '550px' },
						padding: { xs: '20px', md: '30px' },
						display: 'flex',
						flexDirection: 'column',
						gap: '18px',
					}}
				>
					{children}
				</Box>
			</Box>
		</Modal>
	);
};
